<template>
    <div class="position-relative">
        <div class="title-section">
            <img src="@/assets/images/sketch_new.png" class="text-center">
            <p class="light-gray mt-5 mb-2">Vei achiziționa</p>
            <p class="dark-gray mb-5"><strong>1</strong> licență utilizare / <strong>1</strong> proiect / <strong>1</strong> companie</p>
        </div>
        <div class="title-section border-section">
            <div class="flex items-center space-between">
                <p class="dark-gray mb-0 font-small font-weight-bolder price flex-props">Utilizator M2manager</p>
                <p class="light-gray mb-0 flex-props">Cost total:</p>
                <p class="dark-gray mb-0 font-small font-weight-bolder price flex-props">Utilizator termene</p>
            </div>
            <div class="prices-list">
                <div :id="getPriceActive() === 950 ? 'v-step-0' : ''" :class="getPriceActive() === 950 ? 'price-active' : 'price'">
                    <h3 v-if="discounted === null || getPriceActive() !== 950 || getPriceActive() === discounted"><sub>Lei</sub>950</h3>
                    <h3 v-if="getPriceActive() === 950 && discounted !== null && getPriceActive() !== discounted"><del style="font-size: 33px" class="price"><sub>Lei</sub>950</del> &nbsp; <sub>Lei</sub>{{ discounted }}</h3>
                    <p>(fără TVA)</p>
                </div>
                <div :id="getPriceActive() === price ? 'v-step-0' : ''" :class="getPriceActive() === price ? 'price-active' : 'price'">
                    <h3 v-if="discounted === null || getPriceActive() !== price || getPriceActive() === discounted"><sub>Lei</sub>{{ price }}</h3>
                    <h3 v-if="getPriceActive() === price && discounted !== null && getPriceActive() !== discounted"><del style="font-size: 33px" class="price"><sub>Lei</sub>{{ price }}</del> &nbsp; <sub>Lei</sub>{{ discounted }}</h3>
                    <p>(fără TVA)</p>
                </div>
                <div :id="getPriceActive() === 1400 ? 'v-step-0' : ''" :class="getPriceActive() === 1400 ? 'price-active' : 'price'">
                    <h3 v-if="discounted === null || getPriceActive() !== 1400 || getPriceActive() === discounted"><sub>Lei</sub>1400</h3>
                    <h3 v-if="getPriceActive() === 1400 && discounted !== null && getPriceActive() !== discounted"><del style="font-size: 33px" class="price"><sub>Lei</sub>1400</del> &nbsp; <sub>Lei</sub>{{ discounted }}</h3>
                    <p>(fără TVA)</p>
                </div>
            </div>
            <div class="bottom-info">
                <p class="light-gray">În cazul în care ești utilizator M2manager, Termene sau ai primit un tichet de reducere care nu se reflectă în costul de mai sus te rugăm să ne scrii la office@smis.ro</p>
            </div>
        </div>
        <div class="bottom-info">
            <div class="button-list">
                <div id="v-step-1" class="pink-gradient-button" @click="$emit('increaseStep')">Continuă către facturare</div>
                <ModalLicenta :licenseModal="licenseModal" :statistics="statistics" @hideTempModal="licenseModal = false"></ModalLicenta>
                <div class="black-gradient-button" @click="$emit('switchSelection')">Comandă mai multe licențe</div>
            </div>
        </div>

    </div>

</template>

<script>
    import ModalLicenta from './ModalLicenta'
    export default{
        components: {
            ModalLicenta
        },
        props: {
            data: null,
            price: null,
            discounted: null,
            licenseModalShowed: null,
        },
        data() {
            return {
                licenseModal: false,
            }
        },
        computed: {
            statistics() {
                return this.$store.getters['m3Sketch/indicators']
            },
        },
        mounted() {
            this.showLicenseModal()
        },
        methods: {
            getPriceActive() {
                if(this.data.m2manager) {
                    return 950
                } else if(this.data.utm_source === 'termene') {
                    return 1400
                }

                return this.price
            },
            showLicenseModal() {
                if(!this.licenseModalShowed) {
                    this.licenseModal = true
                    this.$emit('licenseModalShowed')
                }
            }
        }
    }
</script>

<style scoped>
.light-gray{
    color: #969db6;
}
.dark-gray{
    color: #545a6f;
}
.title-section p{
    font-size: 21px;
    font-weight: 500;
    text-align: center;
}
.items-center{
    align-items: center;
}
.space-between{
    justify-content: space-between;
}
.title-section img{
    width: 100%;
    object-fit: none;
    max-height: 50px;
}
.prices-list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
}
.price{
    width: 100%;
    opacity: 0.1;
    text-align: center;
    flex: 1 1 0%;
}
.flex-props{
    flex: 1 1 0%;
    width: 100%;
}
.price-active{
    width: 100%;
    flex: 1 1 0%;
    padding: 7px;
    border: 1px solid #545a6f;
    text-align: center;
}
.price sub, .price-active sub{
    font-size: 35px;
    bottom: 0;
    font-weight: 700;
}
.price h3, .price-active h3{
    font-size: 55px;
    color: #545a6f;
    margin: 0;
    line-height: 1;
    font-weight: 700;
}
.price p, .price-active p{
    font-size: 12px;
    text-align: center;
}
.bottom-info{
    margin-top: 40px;
}
.bottom-info p{
    font-size: 12px;
    text-align: center;
    margin: 0 auto;
    color: #545a6f;
}
.button-list{
    display: flex;
    justify-content: space-evenly;
}
.pink-gradient-button{
    background: linear-gradient(to bottom, #e6ad8a, #a669af);
    padding: 5px;
    text-align: center;
    margin: 15px 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 240px;
    font-size: 15px;
    font-weight: 700;
    transition: 0.4s;
    color: #fff;
    cursor: pointer;
}
.font-small{
    font-size: 15px !important;
}
.black-gradient-button{
    background: linear-gradient(to bottom, #5a5a5a, #686868);
    padding: 5px;
    text-align: center;
    margin: 15px 0;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 240px;
    font-size: 15px;
    font-weight: 700;
    transition: 0.4s;
    color: #fff;
    cursor: pointer;
}
.border-section{
    padding: 35px 20px;
    border: 1px solid #c6c8d1;
    border-radius: 8px;
}
@media (max-width: 1520px){
    .prices-list{
        flex-direction: column;
    }
    .price-active{
        margin: 15px 0;
    }
}
</style>
